/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateSavingsTransferRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {CreateSavingsTransferResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const createSavingsTransfer = (request: CreateSavingsTransferRequest, options?: CashRequestOptions) => post<CreateSavingsTransferRequest, CreateSavingsTransferResponse>("/2.0/cash/create-savings-transfer", request, {...options, rejectOnError: true })